import type { RangeFilterKey, RangeFilterDecimals, FilterStep } from './types';

export const PAY_GAP_THRESHOLD: number = 0.05;

export const ORGANIZATION_LEVEL_KEYS = [
    'organizationLevelOne',
    'organizationLevelTwo',
    'organizationLevelThree',
    'organizationLevelFour',
    'organizationLevelFive',
    'organizationLevelSix'
] as const;

export const RANGE_FILTER_STEP_MAP: Partial<Record<RangeFilterKey, FilterStep>> = {
    comparatio: -1,
    standardDeviationDistance: -1,
    fteWorkHoursPerMonth: -1,
};

export const STEP_DECIMAL_MAP: Record<FilterStep, RangeFilterDecimals> = {
    [-1]: 2,
    [0.1]: 1,
    [1]: 0
};

